<template>
  <div>
    <loader v-if="loading === true"></loader>
    <fetch-error
      v-else-if="employees instanceof FetchError"
      @retry="fetchData()"
      :error="employees"
    ></fetch-error>
    <template v-else>
      <page-title
        heading="کارمندان"
        subHeading="دسترسی های کارمندان را از طریق زیر میتوانید مدیریت کنید."
        buttonTitle="ایجاد کارمند"
        @onClickButton="showCreateEmployeePopup = true"
      />
      <panel-qr-card @sendLink="showInvitePopup = true" />
      <div class="main-wrapper">
        <div class="employee-cont">
          <p class="employee">
            تعداد کل کارمندان مجموعه:
            {{ employees.length }}
            نفر
          </p>
          <vs-row class="flex flex-col m-0 mr-10 mb-5">
            <vs-col
              v-for="(employee, index) in employees"
              :key="index"
              vs-type="flex"
              vs-justify="flex-start"
              class="user-cont"
              :class="
                (selectedEmployee && selectedEmployee.id) === employee.id
                  ? 'selected'
                  : null
              "
            >
              <div class="user-item" @click="onClickEmployee(employee)">
                <img
                  class="avatar"
                  :src="employee.avatar.url || placeholder"
                  :alt="employee.name"
                />
                <div>
                  <p v-if="employee.name" class="name">
                    {{ employee.name }}
                  </p>
                  <p class="phone">
                    {{ employee.phone }}
                  </p>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <employee-abilities
          v-if="selectedEmployee"
          :selectedEmployee="selectedEmployee"
          @employeeDeleted="employeeDeleted"
        />
      </div>

      <vs-popup
        v-if="showInvitePopup"
        title="ارسال لینک ورود"
        :active.sync="showInvitePopup"
      >
        <p class="mb-4">کارمند مورد نظر را انتخاب کنید.</p>

        <p v-if="invitableEmployees.length === 0" class="text-center">
          کارمندی برای ارسال وجود ندارد.
        </p>

        <div
          v-for="employee in invitableEmployees"
          :key="employee.id"
          class="invite-option"
          @click="confirmInvite(employee)"
        >
          <p class="name">{{ employee.name || "بدون نام" }}</p>
          <p class="phone">{{ employee.phone }}</p>
        </div>
      </vs-popup>

      <vs-popup
        v-if="showCreateEmployeePopup"
        title="ایجاد کارمند"
        :active.sync="showCreateEmployeePopup"
      >
        <add-employee
          @close="showCreateEmployeePopup = false"
          :createMode="true"
          @employeeCreated="employeeCreated"
        ></add-employee>
      </vs-popup>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import user_placeholder from "../../assets/images/user-placeholder.png";
  import PageTitle from "../../components/pageTitle/PageTitle.vue";
  import providerApiService from "../../services/api/ProviderApiService";
  import FetchError from "./../../services/api/FetchError";
  import authService from "../../services/AuthService";
  import AddEmployee from "./AddEmployee.vue";
  import EmployeeAbilities from "./EmployeeAbilities.vue";
  import PanelQrCard from "./PanelQrCard.vue";

  export default {
    data() {
      return {
        employees: [],
        showUpdateButton: false,
        showCreateEmployeePopup: false,
        selectedEmployee: null,
        loading: true,
        FetchError,
        placeholder: user_placeholder,
        showInvitePopup: false,
      };
    },
    components: {
      AddEmployee,
      PageTitle,
      EmployeeAbilities,
      PanelQrCard,
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),

      invitableEmployees() {
        return this.employees.filter(
          (employee) => employee.id !== authService.id
        );
      },
    },
    mounted() {
      this.fetchEmployees();
    },
    methods: {
      fetchEmployees() {
        this.loading = true;
        providerApiService
          .getEmployees(this.currentProvider.id)
          .then((res) => {
            this.employees = res.data;
            this.loading = false;
            res.data.forEach((element) => {
              if (element.id === this.selectedEmployee?.id) {
                this.selectedEmployee = element;
              }
            });
          })
          .catch((err) => (this.employees = err));
      },
      confirmInvite(employee) {
        this.showInvitePopup = false;

        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: "ارسال پیامک دسترسی",
          text: `پیامک دسترسی به پنل برای "${
            employee.name || employee.phone
          }" به شماره ${employee.phone} ارسال شود؟`,
          acceptText: "ارسال",
          cancelText: "انصراف",
          accept: () => {
            this.$vs.loading();
            providerApiService
              .inviteEmployee(this.currentProvider.id, employee.id)
              .then(() =>
                this.$vs.notify({
                  text: "پیامک ارسال شد",
                  position: "bottom-center",
                  color: "success",
                })
              )
              .catch((err) =>
                this.$vs.notify({
                  text: err?.message || "پیامک ارسال نشد",
                  position: "bottom-center",
                  color: "danger",
                })
              )
              .finally(() => this.$vs.loading.close());
          },
        });
      },

      onClickEmployee(employee) {
        this.selectedEmployee = employee;
      },
      employeeCreated(user) {
        this.fetchEmployees();
        this.showCreateEmployeePopup = false;
        this.selectedEmployee = user;
      },
      employeeDeleted() {
        this.fetchEmployees();
        this.selectedEmployee = null;
      },
    },
  };
</script>

<style scoped lang="scss">
  .invite-option {
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }

    .name {
      font-weight: 500;
    }

    .phone {
      font-size: 13px;
      opacity: 0.7;
    }
  }

  .user-cont {
    background-color: #ffffff;
    margin: 0 15px;
    margin-top: 15px;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
    cursor: pointer;
    transition: 0.2s all ease-in-out;

    &.selected {
      background-color: rgba(var(--vs-primary), 1);

      .name,
      .phone {
        color: #fff;
      }
    }

    .user-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 15px;
    }
  }

  .main-wrapper {
    display: flex;
    width: 100%;

    .employee-cont {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-width: 400px;
    }

    @media (max-width: 900px) {
      flex-direction: column;

      .employee-cont {
        max-width: none;
        margin-bottom: 30px;
      }
    }
  }

  .avatar {
    display: block;
    width: 50px;
    height: 50px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    border: 1px solid gray;
    padding: 1px;
    margin-right: 10px;
  }

  .employee,
  .name,
  .phone {
    font-size: 15px;
    color: #000000;
    display: block;
  }

  .phone {
    font-size: 14px;
  }

  .name {
    font-size: 15px;
  }
</style>
